// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1DlYO","insightsList":"newBusinessInsightsMenu_insightsList__9lJQI","active":"newBusinessInsightsMenu_active__1rzTQ"};